import { Checkbox, Dropdown, TextField } from '@lego/connect-components-react';
import { Flex } from '@lego/klik-ui';
import type { MenuItem, PriceUnitType } from '../types';

type FilterBarProps = {
  selectAll: boolean;
  onSelectAllChange: (checked: boolean) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  selectedYear: string;
  availableYears: string[];
  selectedPriceUnitTypes: PriceUnitType[];
  availablePriceUnitTypes: PriceUnitType[];
  selectedFilterPriceUnitIds: string[];
  availablePriceUnits: { id: string; label: string }[];
  onYearChange: (value: MenuItem[]) => void;
  onPriceUnitTypeChange: (value: MenuItem[]) => void;
  onFilterPriceUnitChange: (value: MenuItem[]) => void;
};

export const FilterBar = ({
  selectAll,
  onSelectAllChange,
  searchValue,
  onSearchChange,
  selectedYear,
  availableYears,
  selectedPriceUnitTypes,
  availablePriceUnitTypes,
  selectedFilterPriceUnitIds,
  availablePriceUnits,
  onYearChange,
  onPriceUnitTypeChange,
  onFilterPriceUnitChange,
}: FilterBarProps) => (
  <Flex height="36px" gap={2} alignItems="center">
    <div hidden>
      <Checkbox
        aria-label="Select all"
        data-test="select-all"
        label="Select all"
        checked={selectAll}
        onChange={(e) => onSelectAllChange(e.target.checked)}
      />
    </div>
    <div>
      <TextField
        renderStartEnhancer={() => (
          <TextField.Enhancer
            aria-label="search bar"
            iconName="magnifying-glass"
          />
        )}
        id="search-input"
        onChange={(e) => onSearchChange(e.target.value)}
        value={searchValue}
        placeholder="Search"
      />
    </div>
    <div style={{ width: '120px' }}>
      <Dropdown
        fullWidth
        placeholder="Year"
        value={[selectedYear]}
        onChange={(_event, value) => onYearChange(value)}
      >
        {availableYears.length === 0 ? (
          <Dropdown.Option value="__no-items-year" disabled>
            No items
          </Dropdown.Option>
        ) : (
          availableYears.map((year) => (
            <Dropdown.Option key={year} value={year}>
              {year}
            </Dropdown.Option>
          ))
        )}
      </Dropdown>
    </div>
    <div style={{ width: '140px' }}>
      <Dropdown
        fullWidth
        multiple
        placeholder="Type"
        value={selectedPriceUnitTypes}
        onChange={(_event, value) => onPriceUnitTypeChange(value)}
        showClearButton
      >
        {availablePriceUnitTypes.length === 0 ? (
          <Dropdown.Option value="__no-items-type" disabled>
            No items
          </Dropdown.Option>
        ) : (
          availablePriceUnitTypes.map((type) => (
            <Dropdown.Option key={type} value={type}>
              {type}
            </Dropdown.Option>
          ))
        )}
      </Dropdown>
    </div>
    <div style={{ width: '240px' }}>
      <Dropdown
        fullWidth
        multiple
        placeholder="All Price Lists"
        showClearButton
        value={selectedFilterPriceUnitIds}
        onChange={(_event, value) => onFilterPriceUnitChange(value)}
      >
        {availablePriceUnits.length === 0 ? (
          <Dropdown.Option value="__no-items-price-unit" disabled>
            No items
          </Dropdown.Option>
        ) : (
          availablePriceUnits.map((priceUnit) => (
            <Dropdown.Option key={priceUnit.id} value={priceUnit.id}>
              {priceUnit.label}
            </Dropdown.Option>
          ))
        )}
      </Dropdown>
    </div>
  </Flex>
);
